var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hazard",
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hazard-1",
    d: "M27.625,27.625 L27.625,30.28125 L13.28125,30.28125 L13.28125,27.625 L27.625,27.625 Z M20.1875,6.375 C21.0729167,6.90625 21.6927083,7.34895833 22.046875,7.703125 C22.4010417,8.05729167 22.8504736,8.95808123 23.3951708,10.4054937 C24.3377317,12.7528406 24.4375,13.8125 24.2242662,14.3673917 C24.0110323,14.9222835 22.1326206,17.7888959 22.1326206,18.0933319 C22.1326206,18.2399482 22.8292589,19.1121122 23.6807058,20.031525 C24.5321526,20.950892 25.2813827,21.9059271 25.3456615,22.1538887 C25.5090443,22.7839558 25.1044475,23.4490279 24.4575465,23.6138783 C23.9652069,23.7392881 23.6909095,23.5190458 21.6773761,21.3815381 C20.4486621,20.0772532 19.3934559,18.8079506 19.3323237,18.5609035 C19.2254118,18.1285769 19.6750241,17.142641 20.8327616,15.2705252 L21.3208872,14.4812323 C19.2706258,15.2937171 17.9623462,15.8166886 17.3960484,16.0501467 L15.8515593,16.6868672 L15.8011959,18.2544326 C15.7734976,19.1165936 15.671875,22.578125 15.40625,23.375 C15.140625,24.171875 11.1099224,27.2747014 10.6002095,27.6698623 C10.090519,28.0650232 8.5,29.21875 7.703125,28.15625 C6.640625,27.09375 9.39359591,25.4032791 10.09375,24.703125 C10.2708333,24.5260417 11.2416361,23.6452925 13.0061582,22.0608774 L13.0460144,19.3737694 C13.015625,17 13.1330118,16.5186245 11.953125,18.859375 C11.7287111,19.3045741 11.2708407,19.8415583 10.95783,20.1861666 C10.3817767,20.7183055 9.73958333,20.984375 9.03125,20.984375 C9.03125,20.984375 6.99479167,20.71875 2.921875,20.1875 C2.390625,20.1875 1.328125,19.65625 1.59375,18.59375 C1.7654752,17.9068492 2.2967252,17.5526826 3.1875,17.53125 L9.26158887,17.8594089 C11.0559463,14.807303 12.1199552,13.0692473 12.4536156,12.6452419 C12.787276,12.2212365 15.276465,11.0805218 19.9211826,9.22309761 C18.3278942,8.20978254 17.4040063,7.65358567 17.149519,7.55450702 C16.444693,7.2800996 16.46875,7.171875 13.546875,8.765625 C12.070579,9.57087738 11.2090117,9.41631102 10.6974784,8.84254687 C10.2161965,8.30280457 10.4736151,7.41330953 11.2206763,7.03467939 C12.4280389,6.42269784 14.8944569,5.3130097 15.7724469,4.98662411 C16.8584327,4.5829806 17.265625,4.515625 20.1875,6.375 Z M26.5625,6.90625 C28.0295064,6.90625 29.21875,8.09549363 29.21875,9.5625 C29.21875,11.0295064 28.0295064,12.21875 26.5625,12.21875 C25.0954936,12.21875 23.90625,11.0295064 23.90625,9.5625 C23.90625,8.09549363 25.0954936,6.90625 26.5625,6.90625 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hazard-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-3",
    transform: "translate(-33.000000, -485.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-4",
    transform: "translate(16.000000, 466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-7",
    transform: "translate(16.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hazard-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "hazard-10",
    xlinkHref: "#hazard-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "hazard-11",
    fill: "#151515",
    fillRule: "evenodd",
    xlinkHref: "#hazard-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hazard-12",
    mask: "url(#hazard-9)",
    fill: "#151515",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hazard-13",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.0263fe29b02025bba32a78b7b5d34223.svg";
export { ForwardRef as ReactComponent };